export const IP_RULE_FIELD = 'valueDisplay';
export const IP_DESCRIPTION_FIELD = 'description';

export const TYPE_SUBNET = 'subnet';
export const TYPE_IPADDR = 'ipAddress';
export const TYPE_RANGE = 'ipRange';
export const RANGE_SEPARATOR = '-';
